"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgChartData = void 0;
const models_1 = require("../../setup/models");
const models_2 = require("../models");
class OrgChartData {
}
exports.OrgChartData = OrgChartData;
//# sourceMappingURL=org-chart.response.js.map